import { BrowserModule } from '@angular/platform-browser';
import { NgModule,NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule , HTTP_INTERCEPTORS} from "@angular/common/http";
import { InterceptorService } from '@app/services/guards/interceptor.service';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
// import { NZ_I18N, en_US } from 'ng-zorro-antd';

import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';

registerLocaleData(en);


// import 'prismjs';
// import 'prismjs/components/prism-typescript.min.js';
// import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
// import 'prismjs/plugins/line-highlight/prism-line-highlight.js';
import { ErrorPopupComponent } from '@templates/template2/error-popup/error-popup.component';
import { VerifyActionsComponent } from '@templates/template2/verify-actions/verify-actions.component';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { BrowserEventsDirective } from '@app/services/browser-events.directive';

@NgModule({
    declarations: [
        AppComponent, ErrorPopupComponent, VerifyActionsComponent, BrowserEventsDirective
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        BrowserAnimationsModule,
        Ng2GoogleChartsModule,
        ModalModule.forRoot()
    ],
    schemas: [NO_ERRORS_SCHEMA],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        //  { provide: NZ_I18N, useValue: en_US }
        ],
    bootstrap: [AppComponent]
})
export class AppModule { }
